import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSound } from '../redux/actions/notifications';
import { notificationsStateSelector } from '../redux/selectors/notifications';

export const useNotifications = () => {
    const audio = useRef<HTMLAudioElement>(null);
    const dispatch = useDispatch();
    const state = useSelector(notificationsStateSelector);

    const sound = (value: boolean) => {
        dispatch(setSound(value));
    };

    useEffect(() => {
        if (state?.sound) {
            audio.current?.play();
            sound(false);
        }
    }, [state?.sound]);

    return {
        audio,
        sound,
    };
};
